// PartywittyOffers.jsx
import './PartywittyOffers.css';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Autoplay } from "swiper/modules";

import tulips from "../../Assets/tulips.svg";
import offerBG from "../../Assets/offer-icon-bg.svg";
import preBooking from "../../Assets/Pre-Booking.svg";
import payBil from "../../Assets/pay-bil.svg";
import earnNow from "../../Assets/earn-now.jpg";

const PartywittyOffers = ({data, clubData}) => {

    // ✅ Put your cards in an array so Swiper can map over them
    const offers = [
        // {
        //     id: 1,
        //     title: "Discover Your Rewards",
        //     subtitle: "Save Up to ₹200",
        //     buttonText: "Watch Teaser",
        //     img: tulips,
        //     bg: offerBG,
        //     className: "discover-rewards",
        // },
        {
            id: 2,
            title: "Upto 50% Off",
            subtitle: "On Food & Beverages Bill",
            buttonText: "Pre-Booking",
            img: preBooking,
            bg: offerBG,
            className: "pre-booking",
        },
        {
            id: 3,
            title: `Flat ${data?.pwPayDiscount || clubData?.pwPayDiscount || 0}% OFF`,
            subtitle: "For Total bill",
            buttonText: "Pay Bill",
            img: payBil,
            bg: offerBG,
            className: "pay-bil",
        },
        {
            id: 4,
            title: "Earn Up To ₹200",
            subtitle: "Pay Using Partywitty Pay",
            buttonText: "Earn Now",
            img: earnNow,
            bg: offerBG,
            className: "earn-now",
        },
    ];

    return (
        <div className="Pay-by-partywitty d-flex flex-column">
            <div className="title-head d-flex flex-column gap-2">
                <h1 className="font-24 text-white text-center">Partywitty Pay</h1>
                <p className="font-18 text-white">Get Instant Discount On F&amp;B</p>
            </div>

            {/* ✅ Swiper Carousel */}
            <Swiper

                spaceBetween={14}
                loop={true}
                // centeredSlides={true}
                // initialSlide={3}
                pagination={{ clickable: true }}
                // autoplay={{ delay: 3000, disableOnInteraction: false }}
                modules={[Pagination, Autoplay]}
                breakpoints={{
                    0: { slidesPerView: 1 },
                    768: { slidesPerView: 2 },
                    1024: { slidesPerView: 3 },
                    1440: { slidesPerView: 4 },
                }}
            >
                {offers.map((offer) => (
                    <SwiperSlide key={offer.id}>
                        <div className={`dbc-wrap ${offer.className}`}>
                            <div className="dbc-badge">🎉</div>

                            <div className="about-us-inverted-radius d-flex flex-column">
                                <div className="dbc-card-wrap d-flex flex-column gap-2 justify-content-between">
                                    <h3 className="dbc-title">{offer.title}</h3>
                                    <p className="dbc-subtitle">{offer.subtitle}</p>
                                </div>
                                <div>
                                    <button className="btn btn-30">{offer.buttonText}</button>
                                </div>
                            </div>

                            <div className={`bottom-img ${offer.className}`}>
                                <img src={offer.img} alt={offer.title} />
                            </div>
                            <div className="offer-bg">
                                <img src={offer.bg} alt="Offer Background" />
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
};

export default PartywittyOffers;
